// import utils
import { IconContainer } from 'components/mrp/mrp.styles';
import { Icon } from '@sdb/planning-ui';
import { StyledTextWithIconCellTypography } from './TextWithIconCell.styles';
import type { IconAtomPropTypes } from '@sdb/planning-ui/ui-3/packages/icons/__generated__/Icon.atom';

const TextWithIconCell = ({
  value,
  type = 'pen-to-square'
}: {
  value: string;
  type?: IconAtomPropTypes['type'];
}) => (
  <StyledTextWithIconCellTypography>
    {value}
    <IconContainer customIconSize={20}>
      <Icon type={type} color="primary" fontSize="inherit" />
    </IconContainer>
  </StyledTextWithIconCellTypography>
);

export default TextWithIconCell;
